import { TemplatePosition } from './campaign/rulesets/template-position';
import { Audit } from './entity';
import { LifeCycle } from './lifecycle';

export interface RulesetSplitTest extends LifeCycle {
  name?: string;
  type?: RulesetSplitTestType;
  objective?: RulesetSplitTestObjective;

  campaignId?: string;
  rulesetId?: string;

  variants?: TemplateVariant[];
  audit?: Audit;
}

export type RulesetSplitTestType = 'Template';
export type RulesetSplitTestObjective = 'ExtendReach';
export type Variant = TemplateVariant;

export const ObjectiveLabels: { [key in RulesetSplitTestObjective]: string } = {
  ExtendReach: 'Extend Reach',
};

interface BaseVariant {
  name?: string;
  weight?: number;
}

interface TemplateVariant extends BaseVariant {
  templateId?: string;
  templateSelector?: string;
  templatePosition?: TemplatePosition;
  type?: '.TemplateVariant';
}
